import React from 'react';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
import { I_CallJson } from '@Redux/detail/Group/interfaces';
import Spinner from '@components/Common/Spinner';

interface I_Props {
    open: boolean;
    ToggleLightBox: () => void;
    callJson: I_CallJson;
    TelType: number;
    GroupInfo: any;
}

function ContactStaff({ open, ToggleLightBox, callJson, TelType, GroupInfo }: I_Props) {
    const typeTitle = () => {
        switch (TelType) {
            case 1:
                return '國外團體旅遊';
            case 2:
                return '台灣旅遊';
            case 3:
                return '主題旅遊';
            default:
                return '';
        }
    };

    function List() {
        switch (TelType) {
            default:
            case 0:
                return (
                    <>
                        <div className={styles.contactBlock}>
                            <h4>國外團體旅遊</h4>
                            <ul className={styles.foreign}>
                                {Array.isArray(callJson.Data) &&
                                    callJson.Data.map((item, index) => {
                                        if (item.Type == 1) {
                                            return (
                                                <li key={index}>
                                                    {item.Region} {item.Area}-{item.Phone}
                                                </li>
                                            );
                                        }
                                    })}
                            </ul>
                        </div>
                        <div className={styles.contactBlock}>
                            <h4>台灣旅遊</h4>
                            <ul className={styles.foreign}>
                                {Array.isArray(callJson.Data) &&
                                    callJson.Data.map((item, index) => {
                                        if (item.Type == 2) {
                                            return (
                                                <li key={index}>
                                                    {item.Region} {item.Area}-{item.Phone}
                                                </li>
                                            );
                                        }
                                    })}
                            </ul>
                        </div>
                        <div className={styles.contactBlock}>
                            <h4>主題旅遊</h4>
                            <ul className={styles.theme}>
                                {Array.isArray(callJson.Data) &&
                                    callJson.Data.map((item, index) => {
                                        if (item.Type == 3) {
                                            return (
                                                <li key={index}>
                                                    {item.Region} {item.Area}-{item.Phone}
                                                </li>
                                            );
                                        }
                                    })}
                            </ul>
                        </div>
                    </>
                );
            case 1:
            case 2:
            case 3:
                return (
                    <div className={styles.contactBlock}>
                        <h4>{typeTitle()}</h4>
                        <ul className={`${TelType === 3 ? styles.theme : styles.foreign}`}>
                            {Array.isArray(callJson.Data) &&
                                callJson.Data.map((item, index) => {
                                    if (item.Type == TelType) {
                                        return (
                                            <li key={index}>
                                                {item.Region} {item.Area}-{item.Phone}
                                            </li>
                                        );
                                    }
                                })}
                        </ul>
                    </div>
                );
        }
    }

    return (
        <LightBox
            title={
                GroupInfo.TravelType === 0
                    ? '此地區已無產品在架上，若有需求請洽服務人員'
                    : '雄獅訂購電話'
            }
            className="contactStaff"
            open={GroupInfo.GroupID ? open : true}
            ToggleLightBox={
                GroupInfo.GroupID
                    ? ToggleLightBox
                    : () => (location.href = 'https://travel.liontravel.com/')
            }
        >
            <div className={styles.service}>服務時間：週一至週五 09:00 ~ 18:00</div>
            {callJson.isCompleted ? <List /> : <Spinner />}
        </LightBox>
    );
}

export default ContactStaff;
